import React, { Component } from "react";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';
import MDTypography from "components/MDTypography";
import styles from "./index.module.css";
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';


import * as ajax from "helpers/ajax";



export default class MassEdit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modalEdit: false,
            commesse: this.props.commesse,
            workerList: this.props.workers,

            fromCommessa: null,
            toCommessa: null,
            workers: [],
            allDays: true,
            fromDay: null,
            toDay: null,

            fromCommessaError: "",
            toCommessaError: "",
            workersError: "",
            allDaysError: "",
            fromDayError: "",
            toDayError: "",

            amountToEdit: 0,
            buttonDisabled:false,

        };
    }

    componentDidMount = () => {

    }

    workerArray = () => {
        let arr = [];
        arr.push({
            id: "tutti",
            label: "Tutti"
        });
        this.state.workerList.map((el) => {
            arr.push({
                id: el.id,
                label: el.cognome + " " + el.nome
            })
        })
        return arr;
    }

    massEditValidation = () => {
        let err = false;
        if (!this.state.fromCommessa) { this.setState({ fromCommessaError: "Selezionare la commessa di partenza" }); err = true }
        if (!this.state.toCommessa) { this.setState({ toCommessaError: "Selezionare la commessa di arrivo" }); err = true }
        if (this.state.workers.length<=0) { this.setState({ workersError: "Selezionare almeno un operaio" }); err = true }
        if (!this.state.allDays && !this.state.fromDay) { this.setState({ fromDayError: "Selezionare la data di inizio" }); err = true }
        if (!this.state.allDays && !this.state.toDay) { this.setState({ toDayError: "Selezionare la data di fine" }); err = true }

        if (err) { return }
        this.massEdit()
    }

    massEdit = () => {
        let filterCommessa = "filters[commessa]=" + this.state.fromCommessa.id

        let filterDataFrom = "";
        let filterDataTo = "";
        if (!this.state.allDays) {
            filterDataFrom = "&filters[data][$gte]=" + this.state.fromDay;
            filterDataTo = "&filters[data][$lte]=" + this.state.toDay;
        }



        let filterWorker = ""; 

        if (!this.state.workers.some(item => item.id === 'tutti')) {
            this.state.workers.map((el,index) => {
                filterWorker += "&filters[operaio][id][$in][" + index + "]=" + el.id;
            })
        }
        this.setState({ buttonDisabled:true})
        let url = "operai-commesses?" + filterCommessa + filterDataFrom + filterDataTo + filterWorker
        ajax.ajaxGetStrapi(url, this.massEditCallback)
    }

    massEditCallback = (response) => {
        if (window.confirm("Sono state trovate " + response.data.length + " occorrenze. Confermi di voler proseguire?")) {
            if (response.data.length <= 0) {
                this.massEditFinalCallback();
            }
            response.data.map((el) => {
                this.setState({ amountToEdit: response.data.length })
                let data = {
                    "data": {
                        "commessa": this.state.toCommessa.id
                    }
                }
                ajax.ajaxPutStrapi("operai-commesses/" + el.id, data, this.massEditFinalCallback)
            })

        } else {
            this.setState({ buttonDisabled: false })
        }
    }

    massEditFinalCallback = () => {
        let n = this.state.amountToEdit;
        n--;
        this.setState({ amountToEdit: n });
        if (n <= 0) {
            this.props.reload()
            this.setState({ buttonDisabled: false, modalEdit: false, workers: [], fromDay: null, toDay: null, allDays:true })
        }
    }

    render() {
        return (
            <>
                <MDButton variant="gradient" sx={{ marginTop: 5 }} color="warning" onClick={() => this.setState({ modalEdit:true})}>
                    Modifica assegnazioni  &nbsp;
                    <Icon>edit</Icon>
                </MDButton>
                <Modal
                    open={this.state.modalEdit}
                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                    onClose={() => this.setState({ modalEdit: false })}
                    style={{
                        margin: "auto", display: "flex", alignItems: "center", justifyContent: "center"
                    }}
                >
                    <MDBox
                        bgColor={"white"}
                        borderRadius="lg"
                        p={2}
                        minWidth={400}
                        maxWidth={400}
                    >
                        <MDBox
                            variant="gradient"
                            bgColor="info"
                            borderRadius="lg"
                            coloredShadow="info"
                            mx={2}
                            mt={-3}
                            p={2}
                            mb={1}
                            textAlign="center"
                        >
                            <MDTypography variant="h2" fontWeight="medium" color="white" mt={1}>
                                Modifica Assegnazioni
                            </MDTypography>
                        </MDBox>

                        <Grid container={true} >
                            <Grid item sm={12} mb={2}>
                                <Autocomplete
                                    disablePortal
                                    options={this.state.commesse}
                                    renderInput={(params) => <TextField {...params} error={this.state.fromCommessaError} label="Seleziona commessa" />}
                                    value={this.state.fromCommessa ? this.state.fromCommessa.label : ""}
                                    onChange={(event, newValue) => {
                                        this.setState({ fromCommessa: newValue, fromCommessaError: "" })
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container={true} >
                            <Grid item sm={12} mb={2}>
                                <Autocomplete
                                    disablePortal
                                    options={this.state.commesse}
                                    renderInput={(params) => <TextField {...params} error={this.state.toCommessaError} label="Sposta in" />}
                                    value={this.state.toCommessa ? this.state.toCommessa.label : ""}
                                    onChange={(event, newValue) => {
                                        this.setState({ toCommessa: newValue, toCommessaError: "" })
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container={true} >
                            <Grid item sm={12} mb={2}>
                                <Autocomplete
                                    multiple
                                    disablePortal
                                    options={this.workerArray()}
                                    renderInput={(params) => <TextField {...params} error={this.state.workersError} label="Operai" />}
                                    onChange={(event, newValue) => {
                                        this.setState({ workers: newValue, workersError: "" })
                                    }}
                                />
                            </Grid>
                        </Grid>

                        <Grid container={true} >
                            <Grid item sm={12} mb={2}>
                                <FormControlLabel
                                    control={<Switch checked={this.state.allDays} onChange={(e) => this.setState({ allDays: e.target.checked })} />}
                                    label={<MDTypography variant="button">{"Tutti i giorni"}</MDTypography>}
                                />
                                <div style={{ display: this.state.allDays ? "none" : "block" }}>
                                    <Grid container={true} >
                                        <Grid item sm={6} mb={2} pr={1}>
                                            <MDInput
                                                label={"Dal Giorno"}
                                                type={"date"}
                                                fullWidth
                                                onChange={(e) => { this.setState({ fromDay: e.target.value, fromDayError: "" }) }}
                                                error={this.state.fromDayError}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                        <Grid item sm={6} mb={2} pl={1}>
                                            <MDInput
                                                label={"Al Giorno"}
                                                type={"date"}
                                                fullWidth
                                                onChange={(e) => { this.setState({ toDay: e.target.value, toDayError: "" }) }}
                                                InputLabelProps={{ shrink: true }}
                                                error={this.state.toDayError}
                                            />
                                        </Grid>
                                    </Grid>
                                </div>
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs pr={1}>
                                <MDButton disabled={this.state.buttonDisabled} fullWidth color="success" ref={(ref) => this.saveButton = ref} onClick={() => this.massEditValidation()}>
                                    Salva
                                </MDButton>
                            </Grid>
                        </Grid>
                    </MDBox>
                </Modal>
            </>
        )
    }
}


